export interface SupportDetail {
  createdOn: Date;
  sent_to: string;
  designation: string;
  first_name: string;
  issue_type: string;
  last_name: string;
  organisation: string;
  status: string;
  ticket_description: string;
  ticket_id: string;
  user_id: string;
  usr_role_track_id: string;
  employee_id: string;
  email_id: string;
  contact_no: string;
}

export interface TicketResponse {
  status: boolean;
  message: string;
  total_count: number;
  tickets: SupportDetail[];
}

export interface SupportComment {
  comments: string;
  createdOn: string;
  id: string;
  receiverName: ReceiverName[];
  receiver_id: string;
  senderName: SenderName[];
  sender_id: string;
  ticket_id: string;
}

export interface Support {
  first_name: string;
  last_name: string;
  organisation: string;
  designation: string;
  issue_type: string;
  ticket_description: string;
  employee_id: string;
  email_id: string;
  contact_no: string;
}

export interface ReceiverName {
  profile_picture: string;
  receiver_name: string;
}

export interface SenderName {
  profile_picture: string;
  sender_name: string;
}
